<h1 class="title">
  {{ "MERCHANT_APPROVALS.MODAL.REJECT_TITLE" | translate }}
</h1>
<p>
  {{
    "MERCHANT_APPROVALS.MODAL." +
      (data.multiple ? "REJECT_MORE_TEXT" : "REJECT_TEXT") | translate
  }}
</p>

<mat-form-field appearance="outline" class="w-100">
  <mat-label>
    {{ "MERCHANT_APPROVALS.MODAL.NOTE" | translate }}
  </mat-label>
  <textarea
    [(ngModel)]="comment"
    matInput
    cdkTextareaAutosize
    [cdkAutosizeMinRows]="5"
  >
  </textarea>
</mat-form-field>

<div class="action-btns">
  <button
    mat-raised-button
    class="me-3"
    [mat-dialog-close]="{
      agree: false
    }"
  >
    {{ "DIALOG.CANCEL" | translate }}
  </button>
  <button
    mat-raised-button
    color="primary"
    [mat-dialog-close]="{
      agree: true,
      comment: comment
    }"
  >
    {{ "DIALOG.YES" | translate }}
  </button>
</div>
